import { render, staticRenderFns } from "./UserRegistrationProfile.vue?vue&type=template&id=82e32e42"
import script from "./UserRegistrationProfile.vue?vue&type=script&lang=js"
export * from "./UserRegistrationProfile.vue?vue&type=script&lang=js"
import style0 from "./UserRegistrationProfile.vue?vue&type=style&index=0&id=82e32e42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports